import { render, staticRenderFns } from "./gongdan_zhidao.vue?vue&type=template&id=1c0fc44d&scoped=true&"
import script from "./gongdan_zhidao.vue?vue&type=script&lang=js&"
export * from "./gongdan_zhidao.vue?vue&type=script&lang=js&"
import style0 from "./gongdan_zhidao.vue?vue&type=style&index=0&id=1c0fc44d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0fc44d",
  null
  
)

export default component.exports